"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M11.995 6.9s-4.5 0-5.63.297a1.873 1.873 0 00-1.271 1.296C4.8 9.637 4.8 12.004 4.8 12.004s0 2.377.294 3.503a1.844 1.844 0 001.271 1.287c1.139.306 5.63.306 5.63.306s4.51 0 5.64-.297a1.8 1.8 0 001.262-1.287c.303-1.135.303-3.502.303-3.502s.009-2.377-.302-3.52a1.789 1.789 0 00-1.263-1.279c-1.13-.315-5.64-.315-5.64-.315zm-1.431 2.917l3.744 2.188-3.745 2.178V9.817z" }), "YouTube");
//# sourceMappingURL=YouTube.js.map